<!--核心团队实体-->
<template>
  <div style="background-color: #76abee;border-radius: 30px;width: 90%;">
    <el-row style="text-align: center;">

      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">

        <div style="margin-top: 20px">
          <el-avatar :src="team.imgPath" :size="100" @click="fei(team.imgPath)"></el-avatar>
        </div>
        {{ team.username }}
        <p style="background-color: white">口头禅：{{ team.petPhrase }}</p>
        <p>性别：{{ team.sex }}</p>
        <p>
          职位：<span v-for="role in team.roleList" :key="role.id">{{ role.roleName }} </span>
        </p>
        <p>联系电话：{{ team.phoneNum }}</p>
        <p>邮件：{{ team.email }}</p>
        <div style="border: 3px solid #a1ffff;width: 50%;height: 50%;margin: auto;border-radius: 20px">
            <h3>简介：</h3>
            <p>{{ team.briefIntroduction }}</p>
        </div>
        <br>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "CoreTeamItem",
  props: ['team'],
  methods: {
    fei(imgPath){
      console.log('11111111111111111')
      window.location.href = imgPath;
    }
  }
}
</script>

<style scoped>
p{
  margin: 5px;
}
</style>
